import { connectWhipserImage } from "view/assets/images";
import "./NeedConnect.scss";
import { useOutletContext } from "react-router-dom";
import Header from "view/components/layout/Header";

interface OutletContext {
  isConnect: boolean;
  userInfo: any;
  isInWhisper: boolean;
  connectWhisper: () => void;
  disconnectWhisper: () => void;
}

function NeedConnect(props: {}) {
  const {
    isConnect,
    userInfo,
    isInWhisper,
    connectWhisper,
    disconnectWhisper,
  } = useOutletContext<OutletContext>();

  return (
    <div id={"NeedConnect"}>
      <Header />
      <img className="connect-whisper" src={connectWhipserImage} alt="logo" />
      <div className="need-connect-bottom">
        <p className="connect-description">
          Token Swap Service is exclusively provided by Acroswap, a third party
          swap service provider. For details, please refer to the link of{" "}
          <a className="acroswap-link" href="https://acroswap.com">
            Acroswap
          </a>
        </p>
        <button className="connect-button" onClick={connectWhisper}>
          Connect Whisper
        </button>
      </div>
    </div>
  );
}

export default NeedConnect;
